import { render, staticRenderFns } from "./OperatsiyaQoshimcha.vue?vue&type=template&id=c6670c78&scoped=true"
import script from "./OperatsiyaQoshimcha.vue?vue&type=script&lang=js"
export * from "./OperatsiyaQoshimcha.vue?vue&type=script&lang=js"
import style0 from "./OperatsiyaQoshimcha.vue?vue&type=style&index=0&id=c6670c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6670c78",
  null
  
)

export default component.exports